import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BriefDetails } from '@/app/pages/admin-options/pages/brief-details/brief-details';

@Component({
  selector: 'ins-brief-details-tab',
  imports: [BriefDetails],
  templateUrl: './details.html',
  host: { class: 'block h-full min-h-0 w-full min-w-0' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BriefDetailsTab implements OnInit {
  private route = inject(ActivatedRoute);
  readonly briefId = signal<string | undefined>(undefined);

  ngOnInit(): void {
    this.briefId.set(this.route.parent?.snapshot.paramMap.get('briefId') ?? undefined);
  }
}
